module.exports = __webpack_public_path__ + "media/images/mamari/wowma/require-green-e1297f517fe4965edba2884b7d4658d8.png";